import { ChangeDetectionStrategy, Component, effect, EventEmitter, inject, input, Output, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Customer } from '@models/customer';
import { InsurenetInterfaceService } from 'app/core/insurenet-interface/insurenet-interface.service';
import { mustMatch } from '../../../../shared/validators/must-match.validator';
import { TogglePasswordComponent } from 'app/shared/components/toggle-password/toggle-password.component';
import { PortalActionButtonsComponent } from '../../portal-action-buttons/portal-action-buttons.component';

@Component({
    selector: 'app-login-credentials-edit',
    templateUrl: './login-credentials-edit.component.html',
    styleUrl: './login-credentials-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, TogglePasswordComponent, PortalActionButtonsComponent],
})
export class LoginCredentialsEditComponent {
    private formBuilder = inject(FormBuilder);
    private insurenetInterfaceService = inject(InsurenetInterfaceService);

    public customer = input.required<Customer>();

    @Output()
    public close = new EventEmitter<void>();

    @Output()
    public customerChange = new EventEmitter<Customer>();

    protected updating = signal(false);

    protected formGroup = this.formBuilder.group(
        {
            email: ['', [Validators.required, Validators.email]],
            newPassword: ['', Validators.minLength(8)],
            newPasswordConfirmation: [''],
        },
        {
            validators: mustMatch('newPassword', 'newPasswordConfirmation'),
        },
    );

    public constructor() {
        effect(() => {
            this.formGroup.controls.email.setValue(this.customer().mail);
        });
    }
    protected handleSubmit(): void {
        if (this.formGroup.invalid) {
            return;
        }
        this.updating.set(true);
        const newMail = this.formGroup.controls.email.value;
        const newPassword = this.formGroup.controls.newPassword.value;
        if (newPassword === '') {
            this.insurenetInterfaceService.updateLogin(newMail, null).subscribe(() => {
                this.customerChange.emit({ ...this.customer(), mail: newMail });
                this.close.emit();
            });
        } else {
            if (confirm('Bist du sicher, dass du dein Passwort ändern möchtest?')) {
                this.insurenetInterfaceService.updateLogin(newMail, newPassword).subscribe(() => {
                    this.close.emit();
                });
            }
        }
    }
}
